// extracted by mini-css-extract-plugin
export default {"feedback":"Cv","radio_button":"Ev","title":"Fv","text":"Gv","main_btn":"Hv","radio_wrapper":"Iv","buttons_wrapper":"Jv"};
    if(module.hot) {
      // 1711717533136
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  